define.alias("shared/components/shared/post-tagging/color-circle", "calendar/components/shared/post-tagging/color-circle");